module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel06_1280_1280_ja-365da492452e368b34905093f74f1cfc.jpg";